:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizard_1wkpe_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileWizard_1wkpe_7 ._mobileWizardLeftHalf_1wkpe_11 {
    position: relative;
    transition: transform 1.7s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    box-sizing: border-box;
    text-align: center;
    background: #fff;
    width: 50%;
    left: 0;
    top: 0;
    height: 100%;
    min-width: 640px; }
  ._mobileWizard_1wkpe_7 ._mobileWizardTopBar_1wkpe_23 {
    transition: opacity 1.7s ease-in-out;
    opacity: 0;
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    z-index: 1; }
    ._mobileWizard_1wkpe_7 ._mobileWizardTopBar_1wkpe_23 ._topBarLeftWixLogo_1wkpe_31 {
      border-right: none;
      position: absolute;
      left: 23px;
      top: 15px; }
    ._mobileWizard_1wkpe_7 ._mobileWizardTopBar_1wkpe_23 ._mobileWizardTopBarSkip_1wkpe_36 {
      position: absolute;
      font-size: 16px;
      top: 28px;
      right: 36px; }
  ._mobileWizard_1wkpe_7._mobileWizardExpanded_1wkpe_41 ._mobileWizardLeftHalf_1wkpe_11 {
    transform: translateX(0); }
  ._mobileWizard_1wkpe_7._mobileWizardExpanded_1wkpe_41 ._mobileWizardTopBar_1wkpe_23 {
    opacity: 1; }
  ._mobileWizard_1wkpe_7 ._mobileWizardInner_1wkpe_45 {
    top: calc( 50% - 247.5px - 36px);
    position: relative; }
    ._mobileWizard_1wkpe_7 ._mobileWizardInner_1wkpe_45::after {
      content: '';
      border-right: 1px solid #d3edff;
      position: absolute;
      width: 0;
      height: 608px;
      top: 0;
      right: 0; }
    ._mobileWizard_1wkpe_7 ._mobileWizardInner_1wkpe_45 ._currentStepContainer_1wkpe_56 {
      min-height: 400px;
      max-width: 542px;
      margin: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 0; }
    ._mobileWizard_1wkpe_7 ._mobileWizardInner_1wkpe_45 ._mobileWizardActions_1wkpe_63 {
      justify-content: center; }
      ._mobileWizard_1wkpe_7 ._mobileWizardInner_1wkpe_45 ._mobileWizardActions_1wkpe_63 button:first-of-type {
        margin-left: 0; }

._editorStage_1wkpe_68 {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  transition: 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) top; }
  ._editorStage_1wkpe_68._toolsHidden_1wkpe_75 {
    transition-duration: 0.4s; }
  ._editorStage_1wkpe_68._fixed_1wkpe_77 {
    width: max(100%, calc(var(--stage-fixed-width) + 84px));
    overflow-x: clip;
    overflow-y: visible; }

._siteCover_1wkpe_82 {
  position: relative;
  min-height: 100%;
  overflow: hidden; }
  ._siteCover_1wkpe_82._siteCoverTruncated_1wkpe_86 {
    width: calc(100% - var(--stage-right-margin)); }
  ._siteCover_1wkpe_82._siteCoverFixedStage_1wkpe_88 {
    width: var(--stage-fixed-width);
    overflow: visible;
    box-shadow: none;
    margin: 0 auto; }
    ._siteCover_1wkpe_82._siteCoverFixedStage_1wkpe_88._siteCoverFixedStageZoom_1wkpe_93 {
      overflow: hidden; }
  ._siteCover_1wkpe_82._siteCoverSectionsEnabled_1wkpe_95 > *:not(._blockLayerContainer_1wkpe_95) {
    opacity: 1;
    transition: opacity 0.2s; }
  ._siteCover_1wkpe_82._siteCoverSectionsEnabled_1wkpe_95._siteCoverMobileEditor_1wkpe_98 {
    overflow: clip; }
  ._siteCover_1wkpe_82._siteCoverSectionsEnabled_1wkpe_95._siteShadow_1wkpe_100 {
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 10px 0 rgba(0, 0, 0, 0.08), 0 1px 20px 0 rgba(0, 0, 0, 0.08); }
  ._siteCover_1wkpe_82._siteCoverZoomOutTransitioning_1wkpe_102 > *:not(._blockLayerContainer_1wkpe_95) {
    opacity: 0;
    transition: none; }

._fixedEditorStage_1wkpe_106 {
  position: absolute;
  top: 0;
  height: 100%;
  pointer-events: none;
  visibility: hidden;
  width: calc(100% - var(--scrollBarWidth)); }
  ._fixedEditorStage_1wkpe_106 ._fixedEditorStageContentsWrapper_1wkpe_113 {
    pointer-events: auto;
    visibility: visible; }
    ._fixedEditorStage_1wkpe_106 ._fixedEditorStageContentsWrapper_1wkpe_113._fixedStageNoPointerEvents_1wkpe_116 {
      pointer-events: none; }
    ._fixedEditorStage_1wkpe_106 ._fixedEditorStageContentsWrapper_1wkpe_113._fixedStageContentsWrapperSectionsEnabled_1wkpe_118 {
      opacity: 1;
      transition: opacity 0.2s; }
    ._fixedEditorStage_1wkpe_106 ._fixedEditorStageContentsWrapper_1wkpe_113._fixedStageContentsWrapperZoomOutTransitioning_1wkpe_121 {
      opacity: 0;
      transition: none; }

._scalable_1wkpe_125._scalableSiteScale_1wkpe_125 {
  height: 100%;
  transform-origin: center 0; }

._mobileFrameOpacityLayer_1wkpe_129 {
  position: absolute;
  pointer-events: none; }
  ._mobileFrameOpacityLayer_1wkpe_129:before, ._mobileFrameOpacityLayer_1wkpe_129:after {
    content: '';
    position: absolute;
    top: var(--g-mobile-top);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    width: calc((100% - 320px) / 2); }
  ._mobileFrameOpacityLayer_1wkpe_129:before {
    left: 0; }
  ._mobileFrameOpacityLayer_1wkpe_129:after {
    right: 0; }
